import { ValidatorFn } from '@angular/forms';

export function requiredWhen(
  predicate: () => boolean,
  message: boolean | string = true,
): ValidatorFn {
  return (control) => (predicate() && !control.value ? { requiredWhen: message } : undefined);
}
